export type DeltaDirection = 'higher' | 'lower' | 'neutral';

export interface DeltaView {
  text: string;
  tone: 'good' | 'bad' | 'neutral';
}

export function analysisDelta(
  current: number,
  baseline: number | undefined,
  direction: DeltaDirection
): DeltaView | null {
  if (baseline === undefined || baseline === null || Number.isNaN(baseline)) {
    return null;
  }
  if (baseline === 0 && current === 0) {
    return null;
  }
  if (baseline === 0) {
    return {
      text: 'nouveau',
      tone: direction === 'neutral' ? 'neutral' : direction === 'higher' ? 'good' : 'bad'
    };
  }
  const rounded = Math.round(((current - baseline) / Math.abs(baseline)) * 100);
  const tone = rounded === 0 || direction === 'neutral'
    ? 'neutral'
    : direction === 'higher'
      ? (rounded > 0 ? 'good' : 'bad')
      : (rounded > 0 ? 'bad' : 'good');
  const sign = rounded > 0 ? '+' : '';
  return { text: `${sign}${rounded} %`, tone };
}

export function formatPercent(rate: number): string {
  return `${Math.round(rate * 100)} %`;
}

export function formatDuration(seconds: number): string {
  if (seconds < 60) {
    return `${Math.round(seconds)} s`;
  }
  if (seconds < 3600) {
    return `${Math.round(seconds / 60)} min`;
  }
  const hours = seconds / 3600;
  if (hours < 48) {
    return `${hours.toFixed(1)} h`;
  }
  return `${Math.round(hours / 24)} j`;
}
